
import {forkJoin as observableForkJoin,  Observable } from 'rxjs';
import { Component, Injector, OnInit } from '@angular/core';
import {NgbActiveModal} from "@ng-bootstrap/ng-bootstrap";
import {UiStateService} from "../../services/ui-state.service";
import {EventService} from "../../services/event.service";
import {UserService} from "../../services/user.service";
import {TeamService} from "../../services/team.service";
import {ToastrService} from "ngx-toastr";
import { Angulartics2 } from 'angulartics2';
import { BaseDialogComponent } from '../dialogs/base-dialog/base-dialog.component';

@Component({
    selector: 'edit-goal-dialog',
    templateUrl: './edit-goal-dialog.component.html',
    styles: [`
        .form-group {
            z-index: 0;
        }
    `]
})
export class EditGoalDialogComponent extends BaseDialogComponent implements OnInit {
    individualGoal: number;
    teamGoal: number;
    individualGoalErrorMessage: string;
    teamGoalErrorMessage: string;
    settingGoalForFacebook: boolean;
    title: string;

    constructor(
        public activeModal: NgbActiveModal,
        public uiStateService: UiStateService,
        public eventService: EventService,
        private userService: UserService,
        private teamService: TeamService,
        private toastr: ToastrService,
        private angulartics2: Angulartics2,
        injector: Injector
    ) {
        super(injector);
    }

    onTeamGoalChange(value) {
        const totalRaised = this.eventService.getTeamTotalRaised();
        if (value > totalRaised) {
            this.teamGoalErrorMessage = null;
        }
    }

    onIndividualGoalChange(value) {
        const totalRaised = this.eventService.getIndividualTotalRaised();
        if (value > totalRaised) {
            this.individualGoalErrorMessage = null;
        }
    }

    validate() {
        let totalRaised = this.eventService.getIndividualTotalRaised();
        const fundraisingMinimum = this.eventService.selectedEvent.gql.Participant[0].fundraiser.fundraisingMinimum;
        if (this.individualGoal < totalRaised) {
            this.individualGoalErrorMessage = 'New goal can not be less than current total funds.';
            return false;
        } else if (this.individualGoal < fundraisingMinimum) {
            this.individualGoalErrorMessage = 'New goal can not be less than fundraising minimum.';
            return false;
        }

		//don't run the team validation if the user wasn't prompted for the team goal
        if(!this.settingGoalForFacebook) {
            if (this.eventService.selectedEvent.donations.team &&
                this.eventService.selectedEvent.gql.Participant[0].teamRoleType &&
                (this.eventService.selectedEvent.gql.Participant[0].teamRoleType.name === 'CAPTAIN' ||
                    this.eventService.selectedEvent.gql.Participant[0].teamRoleType.name === 'CANDIDATE')) {

                totalRaised = this.eventService.getTeamTotalRaised();

                const teamFundraisingMinimum = this.eventService.selectedEvent.gql.Participant[0].team.fundraiser.fundraisingMinimum;
                if (this.teamGoal < totalRaised) {
                    this.teamGoalErrorMessage = 'New goal can not be less than current total funds.';
                    return false;
                } else if (this.teamGoal < teamFundraisingMinimum) {
                    this.teamGoalErrorMessage = 'New goal can not be less than team fundraising minimum.';
                    return false;
                }
            }
        }
        this.individualGoalErrorMessage = null;
        this.teamGoalErrorMessage = null;
        return true;
    }

    onFormSubmit() {
        if (!this.validate()) return;

        const totalRaised = this.eventService.getIndividualTotalRaised();

        let obs;
        if (this.eventService.selectedEvent.donations.individual.goal !== this.individualGoal) {
            this.angulartics2.eventTrack.next({
                action: 'Edit personal goal',
                properties: {category: 'Home Page'}
            });
            const userObs = this.userService.saveUserGoal(this.eventService.selectedEvent.participantId, this.individualGoal);
            if (!obs) {
                obs = userObs;
            } else {
                obs = observableForkJoin(obs, userObs);
            }
        }
        if (!this.settingGoalForFacebook && this.eventService.selectedEvent.gql.Participant[0].team
            && this.eventService.selectedEvent.gql.Participant[0].team.fundraiser.fundraisingGoal !== this.teamGoal) {
            this.angulartics2.eventTrack.next({
                action: 'Edit team goal',
                properties: {category: 'Home Page'}
            });
            const selectedEvent = this.eventService.selectedEvent;
            const teamObs = this.teamService.saveTeamGoal(selectedEvent.gql.Participant[0].team.teamId, selectedEvent.participantId, this.teamGoal);
            if (!obs) {
                obs = teamObs;
            } else {
                obs = observableForkJoin(obs, teamObs);
            }
        }

        if (obs) {
            obs.subscribe(() => {
                this.eventService.selectedEvent.donations.individual.goal = this.individualGoal;
                this.eventService.selectedEvent.gql.Participant[0].fundraiser.fundraisingGoal = this.individualGoal;
                this.eventService.selectedEvent.donations.individual.percentComplete = Math.ceil((totalRaised / this.individualGoal) * 100);
                if (!this.settingGoalForFacebook && this.eventService.selectedEvent.gql.Participant[0].team) {
                    const teamTotalRaised = this.eventService.getTeamTotalRaised();
					this.eventService.selectedEvent.donations.team.goal = this.teamGoal;
					this.eventService.selectedEvent.gql.Participant[0].team.fundraiser.fundraisingGoal = this.teamGoal;
                    this.eventService.selectedEvent.donations.team.percentComplete = Math.ceil((teamTotalRaised / this.teamGoal) * 100);
                }
                this.toastr.clear();
                this.toastr.success('Goal(s) changed successfully.');
                this.activeModal.close();
            }, err => {
                this.toastr.error(JSON.parse(err['error']).message);
            });
        } else {
            this.toastr.clear();
            this.toastr.success('Goal(s) changed successfully.');
            this.activeModal.close();
        }
    }

    ngOnInit() {
        if(!this.settingGoalForFacebook) {
            this.title = 'Edit Fundraising Goal';
            this.individualGoal = this.eventService.selectedEvent.donations.individual.goal;
            if (this.eventService.selectedEvent.gql.Participant[0].team) {
                this.teamGoal = this.eventService.selectedEvent.gql.Participant[0].team.fundraiser.fundraisingGoal;
            }
        } else {
            this.title = 'Facebook requires a goal other than 0';
            this.individualGoal = this.eventService.selectedEvent.gql.Participant[0].fundraiser.fundraisingMinimum;
        }
    }
}
